import axios from 'axios';
import DataProvider from '../app/data-framework/data-provider';
import LoginService from './login.service';

export default class Api {
  constructor() {}

  static request(config, skipAuth = false) {
    if (!config.url) {
      throw new Error('api.js#request: required config param \'url\' is missing or empty');
    }
    return Api._request(config, skipAuth);
  }

  // TODO: this should be a private method, but private class elements do not have widespread browser support
  //       https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Classes/Private_class_fields
  static _request(config, skipAuth, retries) {
    if (skipAuth) {
      return doRequest();
    } else {
      try {
        return LoginService.getActiveSession().then((user) => doRequest(user.apiToken.access_token))
            .catch((error) => {
              if (error) {
                let response = error.response;
                if (response) {
                  switch (response.status) {
                    case 401:
                      return Promise.reject('Session Expired.');
                    case 404:
                      return Promise.reject('Resource Not Found.');
                    default:
                      return Promise.reject(response.data);
                  }
                }
                return Promise.reject(error.message);
              }
              return Promise.reject('Unknown Server Error');
            });
      } catch (e) {
        return Promise.reject('Due to inactivity or session length you have been logged out. Please log back in to continue your session.');
      }
    }

    function doRequest(token) {
      let axiosConfig = Object.assign({}, config);
      if (!axiosConfig.hasOwnProperty('withCredentials')) {
        axiosConfig.withCredentials = true;
      }
      if (!axiosConfig.hasOwnProperty('headers')) {
        axiosConfig.headers = {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
      if (token && !skipAuth) {
        axiosConfig.headers['Authorization'] = 'Bearer ' + token;
      }
      // this is only needed for testing out the new query engine in side-by-side mode, can be removed once testing is complete
      if (/\/dashboard\/api/.test(axiosConfig.url)) {
        if (window.sessionStorage.getItem("feature.qe") !== null) {
          axiosConfig.headers["X-FEATURE-QE"] = window.sessionStorage.getItem("feature.qe");
        }
        if (window.sessionStorage.getItem("feature.queries") !== null) {
          axiosConfig.headers["X-FEATURE-QUERIES"] = window.sessionStorage.getItem("feature.queries");
        }
      }

      if (/\/cpmm\/api/.test(axiosConfig.url) && ! /preferences/.test(axiosConfig.url)) {
        if (window.sessionStorage.getItem("feature.events") !== null) {
          axiosConfig.headers["x-feature-events"] = window.sessionStorage.getItem("feature.events");
        }
      }

      return axios.request(axiosConfig)
        .catch(error => {
          let url = config.url;
          if (url && !url.endsWith('/activity')) {
            if (error.response && error.response.status === 401 && !skipAuth) {
              DataProvider.getInstance().logActivity2('wrss', 'api.js', 'HTTP 401', { url: url, token: token }); // todo this will not work
              retries = retries + 1 || 1;
              if (retries > 3) {
                LoginService.logout();
                return;
              } else {
                return Api._request(config, skipAuth, retries);
              }
            } else {
              DataProvider.getInstance().logActivity2('webResourceSecureCallFailure', url, error.message, {
                payload: error.toJSON(),
                retries: retries,
                status: _.get(error, 'response.status'),
              });
            }
          }
          throw error;
        });
    }
  }
}
